var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main',[_c('v-content',[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"column":"","align-center":""}},[_c('div',{staticClass:"display-3 grey--text mb-5"},[_vm._v("\n            "+_vm._s(_vm.title)+"\n          ")]),_vm._v(" "),_c('img',{attrs:{"src":"img/gurbani_logo.png","alt":"Vuetify.js"}})])],1)],1)],1)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed6a454e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/welcome.vue
// module id = M8Wx
// module chunks = 0